import React, { useRef } from "react";
import { formatDateDDMMYYYYHHMMSS } from "../../Utils/data&dateTime";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import print from '../../assets/icons/print.svg';
import close from "../../assets/icons/close.svg";
const HolidayNoticePrint = ({ isOpen, onClose, selectedHoliday }) => {
  const printRef = useRef();

  if (!isOpen || !selectedHoliday) return null;

  const handlePrintNotice = () => {
    const printWindow = window.open("", "_blank", "width=400,height=600");
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Holiday Notice</title>
          <style>
            @media print {
              @page { size: 52mm; margin: 0; }
              body { width: 52mm; margin: 0; font-family: monospace, sans-serif; font-size: 11px; line-height: 1.4; }
            }
            body {
              width: 52mm;
              margin: 0 auto;
              font-family: monospace, sans-serif;
              font-size: 11px;
              line-height: 1.4;
              text-align: left;
              word-break: keep-all;
            }
            h6 { text-align: center; margin: 2px 0; font-size: 11px; text-decoration: underline; }
            .notice-details p { margin: 2px 0; font-size: 11px; }
            strong { font-weight: 600; font-size: 11px; }
          </style>
        </head>
        <body>
          ${printRef.current.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  const handleDownloadPDF = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("HolidayNotice.pdf");
  };

  const handleShare = async () => {
    if (!navigator.canShare) {
      alert("Sharing not supported on this browser.");
      return;
    }

    const element = printRef.current;
    const canvas = await html2canvas(element, { scale: 2 });
    canvas.toBlob(async (blob) => {
      const file = new File([blob], "HolidayNotice.png", { type: "image/png" });
      try {
        await navigator.share({
          files: [file],
          title: "Holiday Notice",
          text: "Here is the holiday notice",
        });
      } catch (error) {
        console.error("Share failed:", error);
      }
    });
  };

  return (
    <div className="modal-overlay view-admission-print-modal" style={{ padding: "10px" }}>
      <div
        className="print-modal-container"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "90%",
          maxWidth: "600px",
          height: "70vh",
          background: "#fff",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
        }}
      >
        {/* Header */}
        <div
          className="modal-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
            // background: "#f5f5f5",
            borderBottom: "1px solid #ddd"
          }}
        >
          <h4 style={{ margin: 0 }}>Holiday Notice</h4>


          <button className="close-btn" onClick={onClose}>
            <img src={close} alt="close" />
          </button>
        </div>

        {/* Body */}
        <div
          className="modal-body"
          style={{
            padding: "16px",
            overflowY: "auto",
            flex: 1
          }}
        >
          <div ref={printRef} className="feenotice-page">
            <h5 style={{ fontWeight: "bold", textAlign: "center" }}>
              Banaras Institute of Teachers Education, Varanasi
            </h5>
            <p style={{ fontStyle: "italic", textAlign: "center" }}>
              (Affiliated with "Mahatma Gandhi Kashi Vidyapith, Varanasi")
            </p>

            <h6 style={{ fontWeight: "bold", textAlign: "center", textDecoration: "underline" }}>
              HOLIDAY NOTICE
            </h6>

            <div style={{ marginTop: "20px", fontSize: "13px" }}>
              <p><strong>Date:</strong> {formatDateDDMMYYYYHHMMSS(new Date())}</p>
              <p><strong>Holiday Name:</strong> {selectedHoliday.holidayName}</p>
              <p><strong>Type:</strong> {selectedHoliday.holidayType}</p>
              <p><strong>Apply For:</strong> {selectedHoliday.applyFor}</p>
              <p><strong>Course:</strong> {selectedHoliday.course}</p>
              <p><strong>Semester:</strong> {selectedHoliday.semester}</p>
              <p><strong>Section:</strong> {selectedHoliday.section}</p>
              <p><strong>From Date:</strong> {formatDateDDMMYYYYHHMMSS(selectedHoliday.fromDate)}</p>
              <p><strong>To Date:</strong> {formatDateDDMMYYYYHHMMSS(selectedHoliday.toDate)}</p>
              <p><strong>Approved By:</strong> {selectedHoliday.approvedBy}</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          className="modal-footer"
          style={{
            padding: "12px 16px",
            // background: "#f5f5f5",
            borderTop: "1px solid #ddd",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            flexWrap: "wrap"
          }}
        >
          <button onClick={handleDownloadPDF} className="add-btn no-print" style={{ padding: "8px 16px" }}>
            Download PDF
          </button>
          <button onClick={handlePrintNotice} className="add-btn no-print" style={{ padding: "8px 16px", display: "flex", alignItems: "center" }}>
            <img src={print} alt="print" style={{ marginRight: "8px" }} />
            Print
          </button>
          <button
            onClick={handleShare}
            className="add-btn no-print"
            style={{
              backgroundColor: "#4CAF50",
              border: "none",
              borderRadius: "6px",
              padding: "8px 16px",
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer"
            }}
          >
            📤 Share
          </button>
        </div>
      </div>
    </div>
  );
};

export default HolidayNoticePrint;
